<mc-select-list [dataListId]="dataListId" listClass="mc-list-selectable" [listControl]="listControl">
  <ng-template mcListItem let-site>
    <mat-list-item>
      <mc-site-avatar [disabled]="true" [site]="site" size="small" [truncate]="true"></mc-site-avatar>
    </mat-list-item>
  </ng-template>

  <ng-template mcEmptyList>
    <p>No sites found.</p>
  </ng-template>

  <ng-template mcAllItemsLoadedList>
    <p>All sites loaded.</p>
  </ng-template>
</mc-select-list>